import { type MCPServerInfo } from '../../types';

const ServicenowServer: MCPServerInfo = {
  serverId: 'SERVICENOW',
  name: 'ServiceNow',
  slug: 'servicenow',
  description: 'ServiceNow MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/osomai/servicenow-mcp',
    commitSha: '8ada117',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  deprecated: true,
  installConfig: {
    required: [
      'serviceNowInstanceUrl',
      'serviceNowUsername',
      'serviceNowPassword',
      'serviceNowAuthType'
    ],
    properties: {
      serviceNowInstanceUrl: {
        type: 'string',
        description: 'ServiceNow Instance URL',
        sensitive: false
      },
      serviceNowUsername: {
        type: 'string',
        description: 'ServiceNow Username',
        sensitive: false
      },
      serviceNowPassword: {
        type: 'string',
        description: 'ServiceNow Password',
        sensitive: true
      },
      serviceNowAuthType: {
        type: 'string',
        description: 'ServiceNow Authentication Type',
        sensitive: false,
        default: 'basic'
      }
    }
  }
};

export default ServicenowServer;
